<template>

	<li class="feature-tile">
		<div class="feature-tile-wrapper">
			<a v-bind:href="result.NodeAliasPath">
				
				<div class="feature-tile-image" :style="thumbnailImageStyle"></div>
				<div class="feature-tile-info">
					<h4 class="title">
						{{result.Title}}
					</h4>
					<span class="subtext">{{result.Description}}</span>
				</div>
			</a>
		</div>
	</li>

</template>


<script>

	export default {
		props: {
			result: {
				type: Object,
				default: () => { }
			},
		},
		data: function () {
			return {
				
			}
		},
		computed: {
            thumbnailImageStyle: function () {
				return 'background-image: url(' + encodeURI(this.result.Image) + ')'
			}
		},
		methods: {
		}
	}
</script>